import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

import { Contract, User } from 'app/models';
import { UserRole } from 'app/models/enums';

@Injectable()
export class AuthorizationService {
  private readonly user = new BehaviorSubject<User>(null);
  private readonly roles = new BehaviorSubject<string[]>(null);

  constructor() {}

  public getUser(): User {
    return this.user.getValue();
  }

  public hasLoginUser(): boolean {
    return !!this.user.getValue();
  }

  public getContracts(): Contract[] {
    const user = this.user.getValue();
    return user ? user.contracts : [];
  }

  public setAuthenticatedUserAndRoles(user: User, roles: string[]) {
    this.user.next(user);
    this.roles.next(roles);
  }

  public isLocationAdmin(): boolean {
    const roles = this.roles.getValue();
    return roles ? roles.includes(UserRole.CBM_LOCATION_ADMIN) : false;
  }

  public isLocationAdminAsync(): Observable<boolean> {
    return this.roles
      .filter(roles => roles !== null)
      .map(roles => roles.includes(UserRole.CBM_LOCATION_ADMIN))
      .take(1);
  }

  public isMapAdmin(): boolean {
    const roles = this.roles.getValue();
    return roles ? roles.includes(UserRole.CBM_MAP_ADMIN) : false;
  }

  public isLocationOrMapAdmin(): boolean {
    const roles = this.roles.getValue();
    return roles ? roles.includes(UserRole.CBM_LOCATION_ADMIN) || roles.includes(UserRole.CBM_MAP_ADMIN) : false;
  }

  public isApplicationAdmin(): boolean {
    const roles = this.roles.getValue();
    return roles ? roles.includes(UserRole.CBM_APPLICATION_ADMIN) : false;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/authorization.service.ts